import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, inject, input } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, ValidationErrors, ValidatorFn, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash-es';
import { AlertService } from 'src/app/services/alert.service';
import { LoaderService } from 'src/app/services/loader.service';
import { IUser } from 'src/app/models/users.model';
import { FormGroupComponent } from 'src/app/shared/pages/form-group/form-group.component';
import { AuthService } from 'src/app/services/auth.service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';

// @ts-ignore
// const api = require('@modules/cf-api.js').api;;
// const api_async = require('@modules/cf-api.js').api_async;

@Component({
    selector: 'app-password-form',
    templateUrl: './password-form.component.html',
    styleUrls: ['./password-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, RxReactiveFormsModule, MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, TranslatePipe]
})

export class PasswordFormComponent extends FormGroupComponent<any> implements OnInit {
    protected cd = inject(ChangeDetectorRef);
    protected dialog = inject(MatDialog);
    private fb = inject(FormBuilder);
    protected translate = inject(TranslateService);


    readonly user = input<IUser>();
    showPassword: boolean = false;


    constructor() {
        super();

        this.s_loader.loading = false;
    }

    override initForm() {
        this.form = this.fb.group({
            currentPassword: new FormControl('', [Validators.required]),
            newPassword: new FormControl('', [Validators.required]),
            newPasswordConfirm: new FormControl('', [Validators.required])
        }, { validators: this.checkPasswords });
    }

    checkPasswords: ValidatorFn = (controls: AbstractControl): ValidationErrors | null => {
        let newPassword = controls.get('newPassword')?.value;
        let newPasswordConfirm = controls.get('newPasswordConfirm')?.value;
        return newPassword === newPasswordConfirm ? null : { notSame: true };
    };

    toggleVisibility(): void {
        this.showPassword = !this.showPassword;
    }
}